/* Scoped progressive enhancement. Works with Dawn section reloads and block selection. */
(() => {
 if (window.DglGuide) { window.DglGuide.init(document); return; }
 const guides = '.dgl-guide';
 let activeDialog = null;
 const groupButtons = group => [...group.querySelectorAll('[data-dgl-tab]')];
 function selectTab(group, value, updateHash = false) {
  const buttons = groupButtons(group);
  const chosen = buttons.find(b => b.dataset.dglTab === value) || buttons[0];
  if (!chosen) return;
  buttons.forEach(b => b.setAttribute('aria-pressed', String(b === chosen)));
  group.querySelectorAll('[data-dgl-panel]').forEach(panel => {
   panel.hidden = panel.dataset.dglPanel !== chosen.dataset.dglTab;
   if (panel.hidden) panel.querySelectorAll('details[open]').forEach(d => {d.open = false});
  });
  if (updateHash && group.dataset.hashPrefix) history.replaceState(null, '', '#' + group.dataset.hashPrefix + chosen.dataset.dglTab);
 }
 function init(root) {
  const defaultStyle=document.querySelector('[data-dgl-icon-default]')?.dataset.dglIconDefault || 'solid';
  const prefixes={solid:'fas',regular:'far',light:'fal',thin:'fat',duotone:'fad'};
  document.querySelectorAll(`${guides} [data-dgl-icon-style]`).forEach(icon=>{
   const requested=icon.dataset.dglIconStyle==='inherit'?defaultStyle:icon.dataset.dglIconStyle;
   const style=prefixes[requested]?requested:'solid';
   if(icon.tagName.toLowerCase()==='svg'){
    if(icon.getAttribute('data-prefix')===prefixes[style])return;
    const replacement=document.createElement('i');
    replacement.className=icon.getAttribute('class')||'';
    replacement.dataset.dglIconStyle=icon.dataset.dglIconStyle;
    replacement.dataset.dglIconName=icon.dataset.dglIconName;
    replacement.setAttribute('aria-hidden','true');
    icon.replaceWith(replacement);icon=replacement;
   }
   icon.classList.remove('fa-solid','fa-regular','fa-light','fa-thin','fa-duotone','fas','far','fal','fat','fad','svg-inline--fa');
   icon.classList.add('dgl-icon',`fa-${style}`,`fa-${icon.dataset.dglIconName}`);
  });
  // Also supports Pro kits that replace icon elements with inline SVGs.
  if(window.FontAwesome?.dom?.i2svg)document.querySelectorAll(guides).forEach(node=>{
   const conversion=window.FontAwesome.dom.i2svg({node});
   conversion?.catch?.(()=>{});
  });
  root.querySelectorAll(`${guides} [data-dgl-tabs]`).forEach(group => {
   if (group.dataset.dglReady) return;
   group.dataset.dglReady = 'true';
   const prefix = group.dataset.hashPrefix;
   const value = prefix && location.hash.startsWith('#'+prefix) ? location.hash.slice(prefix.length+1) : group.dataset.defaultTab;
   selectTab(group, value);
  });
  root.querySelectorAll(`${guides} details`).forEach(d => {
   if (d.dataset.dglReady) return;
   d.dataset.dglReady='true';d.open=false;
  });
 }
 function closeMenu(section) {
  const button=section.querySelector('[data-dgl-menu-toggle]'),menu=section.querySelector('.guide-menu');
  if (!button || !menu) return;
  menu.hidden=true;button.setAttribute('aria-expanded','false');button.setAttribute('aria-label','Open section menu');
 }
 function scrollToGuideAnchor(anchor,moveFocus=false){
  if(activeDialog?.open)return;
  if(moveFocus){anchor.setAttribute('tabindex','-1');anchor.focus({preventScroll:true})}
  anchor.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
 }
 function guideAnchor(hash){
  let id;try{id=decodeURIComponent(hash.slice(1))}catch{return null}
  const anchor=document.getElementById(id);
  if(anchor?.matches('.dgl-anchor')&&anchor.closest(guides))return anchor;
  for(const group of document.querySelectorAll(`${guides} [data-hash-prefix]`)){
   const prefix=group.dataset.hashPrefix;
   if(id.startsWith(prefix)){
    const stage=id.slice(prefix.length);
    if(!groupButtons(group).some(b=>b.dataset.dglTab===stage))continue;
    selectTab(group,stage);return group.closest(guides).querySelector('.dgl-anchor');
   }
  }
  return null;
 }
 function openDialog(trigger) {
  const template=document.getElementById(trigger.dataset.dglModal);
  const section=trigger.closest(guides);
  if (!template || !section) return;
  if (activeDialog) activeDialog.close();
  const dialog=document.createElement('dialog');
  dialog.className='detail-modal';
  const grip=document.createElement('div');grip.className='drawer-grip';grip.setAttribute('aria-hidden','true');grip.append(document.createElement('span'));
  const close=document.createElement('button');close.className='modal-close';close.type='button';close.textContent='×';
  close.setAttribute('aria-label',document.querySelector('[data-close-label]')?.dataset.closeLabel || 'Close details');
  dialog.append(grip,close,template.content.cloneNode(true));
  const heading=dialog.querySelector('[data-dgl-modal-title]');
  if(heading){heading.id=template.id+'-title';dialog.setAttribute('aria-labelledby',heading.id)}
  section.append(dialog);
  dialog.addEventListener('close',()=>{
   dialog.remove();if(activeDialog===dialog)activeDialog=null;
   if(!activeDialog)document.body.classList.remove('dgl-modal-open');
   if(trigger.isConnected)trigger.focus({preventScroll:true});
  },{once:true});
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
   if(event.target!==dialog)return;
   const r=dialog.getBoundingClientRect();
   if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
  });
  let start=null;
  grip.addEventListener('touchstart',e=>{start=e.touches[0].clientY},{passive:true});
  grip.addEventListener('touchend',e=>{if(start!==null&&e.changedTouches[0].clientY-start>55)dialog.close();start=null},{passive:true});
  activeDialog=dialog;dialog.showModal();document.body.classList.add('dgl-modal-open');close.focus({preventScroll:true});
 }
 document.addEventListener('click',event=>{
  const target=event.target.closest?.(guides);
  document.querySelectorAll(`${guides}[data-dgl-section="navigation"]`).forEach(section=>{if(section!==target)closeMenu(section)});
  if(!target)return;
  const button=event.target.closest('[data-dgl-tab]');
  if(button)selectTab(button.closest('[data-dgl-tabs]'),button.dataset.dglTab,true);
  const menuToggle=event.target.closest('[data-dgl-menu-toggle]');
  if(menuToggle){const menu=target.querySelector('.guide-menu');menu.hidden=!menu.hidden;menuToggle.setAttribute('aria-expanded',String(!menu.hidden));menuToggle.setAttribute('aria-label',menu.hidden?'Open section menu':'Close section menu')}
  if(event.target.closest('.guide-menu a'))closeMenu(target);
  const link=event.target.closest('a[href]');
  if(link&&!event.defaultPrevented&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&!link.hasAttribute('download')&&(!link.target||link.target==='_self')){
   const url=new URL(link.href,location.href);
   if(url.origin===location.origin&&url.pathname===location.pathname&&url.search===location.search&&url.hash){
    const anchor=guideAnchor(url.hash);
    if(anchor){event.preventDefault();if(location.hash!==url.hash)history.pushState(null,'',url.hash);scrollToGuideAnchor(anchor,true)}
   }
  }
  const modalTrigger=event.target.closest('[data-dgl-modal]');if(modalTrigger)openDialog(modalTrigger);
 });
 document.addEventListener('keydown',event=>{
  if(event.key==='Escape')document.querySelectorAll(`${guides} .guide-menu:not([hidden])`).forEach(menu=>{const section=menu.closest(guides);closeMenu(section);section.querySelector('[data-dgl-menu-toggle]').focus()});
  const button=event.target.closest?.('[data-dgl-tab]');
  if(button&&['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){
   event.preventDefault();const group=button.closest('[data-dgl-tabs]'),buttons=groupButtons(group),index=buttons.indexOf(button);
   const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
   buttons[next].focus();selectTab(group,buttons[next].dataset.dglTab,true);
  }
 });
 document.addEventListener('toggle',event=>{
  if(event.target.tagName==='DETAILS'&&event.target.open&&event.target.closest(guides))document.querySelectorAll(`${guides} details[open]`).forEach(d=>{if(d!==event.target)d.open=false});
 },true);
 function handleHash(scroll=false){
  document.querySelectorAll(`${guides} [data-hash-prefix]`).forEach(group=>{
   const prefix=group.dataset.hashPrefix;
   if(location.hash.startsWith('#'+prefix)){selectTab(group,location.hash.slice(prefix.length+1));if(scroll){const anchor=group.closest(guides).querySelector('.dgl-anchor');if(anchor)scrollToGuideAnchor(anchor)}}
  });
 }
 window.addEventListener('hashchange',()=>handleHash(true));
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{if(activeDialog&&event.target.contains(activeDialog))activeDialog.close()});
 document.addEventListener('shopify:block:select',event=>{
  const panel=event.target.closest('[data-dgl-panel]');
  if(panel)selectTab(panel.closest('[data-dgl-tabs]'),panel.dataset.dglPanel);
  if(event.target.matches('details'))event.target.open=true;
 });
 let queued=false;
 window.addEventListener('scroll',()=>{
  if(queued)return;queued=true;
  requestAnimationFrame(()=>{
   const current=[...document.querySelectorAll(`${guides} .dgl-anchor`)].filter(a=>a.getBoundingClientRect().top<180).at(-1);
   document.querySelectorAll(`${guides} .desktop-nav a`).forEach(a=>{if(current&&a.hash==='#'+current.id)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});queued=false;
  });
 },{passive:true});
 window.DglGuide={init};
 init(document);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init(document);handleHash(true)},{once:true});
 else handleHash(true);
})();
